import type { MeterState } from "../api/types";

/**
 * Индикатор связи.
 *
 * Цвет здесь никогда не единственный признак: рядом всегда стоит подпись,
 * иначе статус был бы нечитаем при дальтонизме и в чёрно-белой печати.
 */
export function StatusBadge({ state, interval }: { state: MeterState; interval?: number }) {
  const online = state.online;
  const cls = online ? "good" : "bad";
  const label = online ? "на связи" : "нет связи";

  const title = online
    ? state.lastSeen
      ? `Последний замер: ${new Date(state.lastSeen).toLocaleTimeString("ru-RU")}`
      : undefined
    : state.lastError || "нет данных";

  return (
    <span className={`status ${cls}`} title={title}>
      <span className="dot" aria-hidden="true" />
      {label}
      {!online && state.errStreak > 0 && ` (ошибок подряд: ${state.errStreak})`}
      {online && interval ? <span className="muted"> · опрос {formatInterval(interval)}</span> : null}
    </span>
  );
}

function formatInterval(ms: number): string {
  if (ms % 60000 === 0) return `${ms / 60000} мин`;
  if (ms % 1000 === 0) return `${ms / 1000} с`;
  return `${ms} мс`;
}

/** Индикатор соединения браузера с сервером. */
export function LinkBadge({ status }: { status: "connecting" | "online" | "offline" }) {
  const map = {
    connecting: { cls: "warn", label: "подключение…" },
    online: { cls: "good", label: "поток данных активен" },
    offline: { cls: "bad", label: "нет связи с сервером" },
  } as const;
  const { cls, label } = map[status];
  return (
    <span className={`status ${cls}`}>
      <span className="dot" aria-hidden="true" />
      {label}
    </span>
  );
}
